export { Decorations } from './decorations.js';
